import React from "react";
import "../../styles/navbar.css";
import { Link } from "react-router-dom";
import { Badge, IconButton, Tooltip } from "@mui/material";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
// import VerifiedIcon from "@mui/icons-material/Verified";
import { useCart } from "../../services/CartContext";
import Tlogo from "../../assets/TRADE_DUKA.avif";
// Import your Quickmart logo asset (update path as needed)
// import QuickmartLogo from "../../assets/QLogo.avif";
import { usePWAInstall } from "../../utility/InstallButton";
import { useCampaign } from "../../hooks/useCampaign";

const Navbar = ({ campaignCode, onChangeBranch }) => {
  const code = campaignCode || localStorage.getItem("campaignCode");
  const { canInstall, installApp } = usePWAInstall();
  const { data: campaign } = useCampaign(campaignCode);
  const { cart } = useCart();

  // Replace with your business WhatsApp phone number (in international format without '+')
  const whatsappNumber = "254116088688";
  const whatsappMessage = encodeURIComponent(
    "Hello! I need assistance with Trade Duka.",
  );

  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <header className="header">
      {/* Primary Navigation Bar */}
      <nav className="nav container">
        {/* LOGO */}
        <Link to={code ? `/${code}` : "/"} className="nav__logo">
          <img src={Tlogo} className="logo__image" alt="Trade Duka Logo" />
        </Link>

        {/* VERIFIED PARTNER BADGE */}
        {/* <div className="verified-badge">
          <VerifiedIcon
            className="verified-badge__check-icon"
            fontSize="small"
          />
          <span className="verified-badge__text">Verified Partner of</span>
          <img
            src={QuickmartLogo}
            alt="Quickmart"
            className="verified-badge__logo"
          />
        </div> */}

        {/* RIGHT ACTION BUTTONS */}
        <div className="navbar-right">
          {/* WhatsApp Action Button */}
          <Tooltip title="Chat with us on WhatsApp" arrow>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-btn"
              aria-label="Contact us on WhatsApp"
            >
              <WhatsAppIcon className="whatsapp-btn__icon" />
              <span className="whatsapp-btn__text">Chat</span>
            </a>
          </Tooltip>

          {/* PWA Install Button */}
          {canInstall && (
            <div className="downloadButton">
              <button
                className="installBtn"
                onClick={installApp}
                title="Install App"
              >
                <i className="bx bx-download"></i>
              </button>
            </div>
          )}

          {/* Cart Button */}
          <IconButton
            component={Link}
            to="/cart"
            state={{ campaignCode }}
            className="cart-btn"
          >
            <Badge badgeContent={cart?.items?.length || 0} color="error">
              <ShoppingCartOutlinedIcon />
            </Badge>
            <span className="cart-text">Cart</span>
          </IconButton>
        </div>
      </nav>

      {/* Secondary Location Bar */}
      <nav className="nav__sub">
        <div className="nav__sub-div container">
          <div className="nav__shop-location">
            <p className="shop__name">
              <i className="bx bx-store" />
              <span className="shop__name-text">
                {campaign?.name || "Select Branch"}
              </span>
            </p>
          </div>
          <div className="nav__shop-change">
            <button className="change-btn" onClick={onChangeBranch}>
              <span>Change Branch</span>
              <i className="bx bx-chevron-right" />
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
